export default __webpack_public_path__ + "static/media/Product_News_Banner.4666213e.png";